'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Tv = function (_React$Component) {
    _inherits(Tv, _React$Component);

    function Tv() {
        _classCallCheck(this, Tv);

        return _possibleConstructorReturn(this, (Tv.__proto__ || Object.getPrototypeOf(Tv)).apply(this, arguments));
    }

    _createClass(Tv, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M18.927 27.122c0 .4-.307.707-.707.707H7.282c-.4 0-.707-.308-.707-.708s.307-.707.707-.707H7.19c1.26-.154 1.936-.676 2.304-1.168h6.544c.37.522 1.045 1.014 2.304 1.168h-.123c.398 0 .706.307.706.707zm6.636-7.712v3.072c-.03.86-.768 1.567-1.628 1.567H1.63c-.892 0-1.6-.708-1.63-1.568v-.03-.155-2.52V6.043C0 5.03.83 4.17 1.876 4.17H23.72c1.014 0 1.874.83 1.874 1.873l-.03 13.365zm-11.307 2.58c0-.214-.184-.398-.4-.398h-2.15c-.215 0-.4.184-.4.4v.276c0 .215.185.4.4.4h2.15c.216 0 .4-.185.4-.4v-.277zm9.77-2.242V6.045c0-.184-.153-.338-.337-.338H1.843c-.184 0-.338.154-.338.338v13.703c0 .184.154.338.338.338H23.69c.183-.03.337-.154.337-.338zM12.475 9.855c-.184.03-.37.03-.553.06-1.443.247-2.61.953-3.563 2.09-.092.123-.092.277 0 .4.123.122.215.245.338.337.092.092.215.092.307-.03.06-.062.123-.124.154-.216 1.23-1.475 3.226-2.06 5.04-1.444.92.307 1.69.86 2.273 1.628.122.154.245.154.368.03.092-.09.184-.183.277-.306.154-.154.154-.277.03-.46-.245-.308-.552-.615-.86-.86-.83-.677-1.75-1.076-2.795-1.23-.123-.03-.277-.03-.4-.06-.214.06-.398.06-.613.06zm.4 7.098c.03 0 .06-.03.092-.03.277-.093.43-.37.4-.677-.062-.307-.278-.522-.585-.522-.276 0-.52.184-.583.492s.092.584.338.707c.03.03.06.03.123.03h.215zm2.95-3.534c-.953-1.2-2.152-1.752-3.657-1.507-1.014.154-1.813.707-2.427 1.536-.092.122-.092.276 0 .368.123.154.246.277.4.4.06.06.183.06.245-.032.03-.03.03-.06.06-.092.738-1.106 2.12-1.536 3.35-1.075.584.214 1.014.583 1.383 1.105.123.184.215.184.37.03l.306-.306c.06-.062.092-.155.123-.216-.092-.06-.123-.154-.154-.215zm-1.23 1.32c-.43-.522-.983-.83-1.66-.86-.798-.06-1.443.246-1.965.86-.093.123-.093.277 0 .4l.368.368c.092.092.184.092.277 0 .03-.03.06-.06.092-.123.37-.43.86-.614 1.413-.492.338.092.614.277.83.553.092.123.215.123.307.03l.338-.337c.06-.062.092-.155.123-.216-.06-.06-.06-.154-.123-.184z' })
            );
        }
    }]);

    return Tv;
}(_react2.default.Component);

Tv.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Tv;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/tv.js
// module id = 1128
// module chunks = 0